// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer defaults {
  :root {
    --readthedocs-filetreediff-font-size: calc(
      var(--readthedocs-font-size) * 0.85
    );
    --readthedocs-filetreediff-font-family: var(--readthedocs-font-family);

    --readthedocs-filetreediff-color: rgb(252, 252, 252);
    --readthedocs-filetreediff-background-color: rgb(39, 39, 37);
    --readthedocs-filetreediff-border-color: #ddd;
    --readthedocs-filetreediff-label-color: #333;
    --readthedocs-filetreediff-chunks-color: #27ae60;
    --readthedocs-filetreediff-icon-width: 0.8rem;
  }
}

:host > div {
  position: fixed;
  top: 0;
  right: 1em;
  color: var(--readthedocs-filetreediff-color);
  background-color: var(--readthedocs-filetreediff-background-color);
  padding: 0.25em 0.75em;
  box-shadow: 0 0.1em 0.25em rgba(0, 0, 0, 0.1);
  z-index: 2000;
  border-radius: 0 0 0.375em 0.375em;
  font-size: var(--readthedocs-filetreediff-font-size);
  font-family: var(--readthedocs-filetreediff-font-family);
}

:host > div > div {
  display: flex;
  gap: 0.75em;
  align-items: center;
}

:host > div > div > select {
  flex: 1;
  padding: 0.25em 0.5em;
  border: 0;
  color: var(--readthedocs-filetreediff-color);
  background-color: var(--readthedocs-filetreediff-background-color);
  border-radius: 0.25em;
  appearance: revert;
}

:host > div > div > label {
  display: flex;
  align-items: center;
  gap: 0.35em;
  white-space: nowrap;
  cursor: pointer;
}

:host > div > div > label > input {
  margin: 0;
}

:host > div > div > span:not(.chunks) {
  display: flex;
  width: 0.5em;
  cursor: pointer;
}

:host > div > div > span:not(.chunks) svg {
  min-height: 1em;
}

:host > div > div > span.chunks {
  color: var(--readthedocs-filetreediff-chunks-color);
  font-weight: bold;
  display: flex;
  min-width: 2.5em;
}

:host > div > div > a {
  width: var(--readthedocs-filetreediff-icon-width);
  color: var(--readthedocs-filetreediff-color);
}

:host > div > div > a.version {
  width: auto;
  text-decoration: none;
  color: var(--readthedocs-filetreediff-chunks-color, #27ae60);
}

/* Expand to full width on smaller screens */
@media (max-width: 768px) {
  :host > div {
    width: calc(100% - 1em);
    margin: 0;
    right: 0;
    border-radius: 0;
    padding: 0.5em;
  }

  :host > div > div > select {
    width: 100%;
    border: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/filetreediff.css"],"names":[],"mappings":"AAAA;EACE;IACE;;KAEC;IACD,sEAAsE;;IAEtE,oDAAoD;IACpD,4DAA4D;IAC5D,6CAA6C;IAC7C,4CAA4C;IAC5C,gDAAgD;IAChD,6CAA6C;EAC/C;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,UAAU;EACV,4CAA4C;EAC5C,kEAAkE;EAClE,sBAAsB;EACtB,6CAA6C;EAC7C,aAAa;EACb,kCAAkC;EAClC,oDAAoD;EACpD,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,SAAS;EACT,4CAA4C;EAC5C,kEAAkE;EAClE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA,4CAA4C;AAC5C;EACE;IACE,uBAAuB;IACvB,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;AACF","sourcesContent":["@layer defaults {\n  :root {\n    --readthedocs-filetreediff-font-size: calc(\n      var(--readthedocs-font-size) * 0.85\n    );\n    --readthedocs-filetreediff-font-family: var(--readthedocs-font-family);\n\n    --readthedocs-filetreediff-color: rgb(252, 252, 252);\n    --readthedocs-filetreediff-background-color: rgb(39, 39, 37);\n    --readthedocs-filetreediff-border-color: #ddd;\n    --readthedocs-filetreediff-label-color: #333;\n    --readthedocs-filetreediff-chunks-color: #27ae60;\n    --readthedocs-filetreediff-icon-width: 0.8rem;\n  }\n}\n\n:host > div {\n  position: fixed;\n  top: 0;\n  right: 1em;\n  color: var(--readthedocs-filetreediff-color);\n  background-color: var(--readthedocs-filetreediff-background-color);\n  padding: 0.25em 0.75em;\n  box-shadow: 0 0.1em 0.25em rgba(0, 0, 0, 0.1);\n  z-index: 2000;\n  border-radius: 0 0 0.375em 0.375em;\n  font-size: var(--readthedocs-filetreediff-font-size);\n  font-family: var(--readthedocs-filetreediff-font-family);\n}\n\n:host > div > div {\n  display: flex;\n  gap: 0.75em;\n  align-items: center;\n}\n\n:host > div > div > select {\n  flex: 1;\n  padding: 0.25em 0.5em;\n  border: 0;\n  color: var(--readthedocs-filetreediff-color);\n  background-color: var(--readthedocs-filetreediff-background-color);\n  border-radius: 0.25em;\n  appearance: revert;\n}\n\n:host > div > div > label {\n  display: flex;\n  align-items: center;\n  gap: 0.35em;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n:host > div > div > label > input {\n  margin: 0;\n}\n\n:host > div > div > span:not(.chunks) {\n  display: flex;\n  width: 0.5em;\n  cursor: pointer;\n}\n\n:host > div > div > span:not(.chunks) svg {\n  min-height: 1em;\n}\n\n:host > div > div > span.chunks {\n  color: var(--readthedocs-filetreediff-chunks-color);\n  font-weight: bold;\n  display: flex;\n  min-width: 2.5em;\n}\n\n:host > div > div > a {\n  width: var(--readthedocs-filetreediff-icon-width);\n  color: var(--readthedocs-filetreediff-color);\n}\n\n:host > div > div > a.version {\n  width: auto;\n  text-decoration: none;\n  color: var(--readthedocs-filetreediff-chunks-color, #27ae60);\n}\n\n/* Expand to full width on smaller screens */\n@media (max-width: 768px) {\n  :host > div {\n    width: calc(100% - 1em);\n    margin: 0;\n    right: 0;\n    border-radius: 0;\n    padding: 0.5em;\n  }\n\n  :host > div > div > select {\n    width: 100%;\n    border: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
